import { ReactNode } from 'react'
import { SWRConfig as LibSWRConfig } from 'swr'

const SWRConfig = (props: { children: ReactNode }) => {
  return (
    <LibSWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
      }}
    >
      {props.children}
    </LibSWRConfig>
  )
}

export default SWRConfig
